import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { nestedFieldValueGetter } from 'utils/grid';

import type { GridColDef } from '@mui/x-data-grid-pro';

export const useGetColumnDefs = (): GridColDef[] => {
  const { t } = useTranslation('common', { keyPrefix: 'yearClosure' });
  return useMemo(
    () => [
      {
        field: 'employee.nameCompound',
        headerName: t('employee_name'),
        type: 'string',
        valueGetter: (_, row, column) =>
          nestedFieldValueGetter(column.field, row),
        filterable: false,
        sortable: false,
        flex: 1,
        minWidth: 250
      },
      {
        field: 'employee.nr',
        headerName: t('employee_nr'),
        type: 'string',
        valueGetter: (_, row, column) =>
          nestedFieldValueGetter(column.field, row),
        filterable: false,
        sortable: false,
        minWidth: 120
      },
      {
        field: 'key',
        headerName: t('progress_bar.error_details_grid.key'),
        type: 'string',
        filterable: false,
        sortable: false,
        flex: 1,
        minWidth: 200
      }
    ],
    [t]
  );
};
